import {useCallback, useState} from 'react';
import type {TodoCandidateWithId} from './useAiTodoGeneration';

type EditState = {
  editingIndex: number | null;
  editingCandidate: TodoCandidateWithId | null;
};

export const useAiTodoEdit = () => {
  const [candidates, setCandidates] = useState<TodoCandidateWithId[]>([]);
  const [editState, setEditState] = useState<EditState>({
    editingIndex: null,
    editingCandidate: null,
  });

  const startEdit = useCallback(
    (index: number) => {
      const candidate = candidates[index];
      if (candidate) {
        setEditState({
          editingIndex: index,
          editingCandidate: {
            candidateId: candidate.candidateId,
            title: candidate.title,
            body: candidate.body,
            dueDate: candidate.dueDate,
            priority: candidate.priority,
            link: candidate.link,
          },
        });
      }
    },
    [candidates],
  );

  const cancelEdit = useCallback(() => {
    setEditState({
      editingIndex: null,
      editingCandidate: null,
    });
  }, []);

  const updateCandidate = useCallback(
    (index: number, updated: TodoCandidateWithId) => {
      setCandidates((prev) => {
        const newCandidates = [...prev];
        newCandidates[index] = updated;
        return newCandidates;
      });
      setEditState({
        editingIndex: null,
        editingCandidate: null,
      });
    },
    [],
  );

  const resetEditState = useCallback(() => {
    setCandidates([]);
    setEditState({
      editingIndex: null,
      editingCandidate: null,
    });
  }, []);

  return {
    candidates,
    setCandidates,
    editState,
    startEdit,
    cancelEdit,
    updateCandidate,
    resetEditState,
  };
};
